import {Component} from "react";

class InPlayer extends Component {
    render() {
        return (
            <div className="ad-in-player">
                <iframe className="na" frameBorder="0" scrolling="no" width="300" height="300"
                        src="//a.o333o.com/api/spots/53915?p=1" />
            </div>
        )
    }
}

export default InPlayer



// WEBPACK FOOTER //
// components/ads/InPlayer.js